import type { LogoutResponse } from '@repo/contracts';

import { apiClient } from '@/shared/api/axios';

export const logout = async (): Promise<LogoutResponse> => {
  const response = await apiClient.post<LogoutResponse>('/auth/logout');
  return response.data;
};
